import { render, staticRenderFns } from "./DisqualificationDestroyConfirm.vue?vue&type=template&id=07bf03ad"
import script from "./DisqualificationDestroyConfirm.vue?vue&type=script&lang=js"
export * from "./DisqualificationDestroyConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports